(function () {
    'use strict';

    angular.module('quantixApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$ocLazyLoadProvider'];

    function stateConfig($stateProvider, $ocLazyLoadProvider) {

        $ocLazyLoadProvider
            .config({
                'debug': false,
                /*
                 * for debugging ocLazyLoad module
                 * 'true/false'
                 */
                'events': true,
                /*
                 * for event ocLazyLoad module
                 * 'true/false'
                 */
                'modules': [{
                        name: 'fsmModule',
                        /*
                         * injecting 
                         * Module for ocLazyLoad
                         */
                        /* files for lazy load */
                        files: [
                            'app/analytics/creditSensitivityModel/creditSensitivityMain.controller.js',
                            'app/services/analytics/financialSensitivity.service.js',
                            'app/services/analytics/financialSensitivityUnlisted.service.js',
                            'app/analytics/creditSensitivityModel/alertSettingController.js',
                            'app/services/analytics/fsmAlertTracker.service.js',
                            'app/services/analytics/financialAdvantage.service.js',
                            'app/analytics/creditSensitivityModel/financialAdvantageModal/financialAdvantageDialogController.js',
                            'app/analytics/creditSensitivityModel/financialAdvantage/star-rating.js',
                            'app/analytics/creditSensitivityModel/creditSensitivityFmsm.controller.js'
                        ]
                    },
                    {
                        name: 'famModule',
                        files: [
                            'app/services/analytics/financialAdvantage.service.js',
                            'app/analytics/creditSensitivityModel/financialAdvantage/financialAdvantageController.js'

                        ]
                    }


                ]
            });
        $stateProvider
            .state('financialSensitivityMain', {
                parent: 'app',
                url: '/financialSensitivityMain',
                params: {
                    companyCode: null,
                    listedFlag: null,
                    segement: null,
                    hideLanding: false,
                    redirectFsmFlag:false,
                    companyflag:null 
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        controller: 'CreditSensitivityMainController',
                        templateUrl: 'app/analytics/creditSensitivityModel/financial_sensitivity_search.html'
                    }
                },
                resolve: {
                    loadMyCtrl: [
                        '$ocLazyLoad',
                        function ($ocLazyLoad) {
                            return $ocLazyLoad
                                .load('fsmModule');
                            /*
                             * Resolve
                             * promise
                             * and
                             * load
                             * before
                             * view
                             */
                        }
                    ]
                }
            })
            .state(
                'financialadvantage', {
                    parent: 'app',
                    url: '/financialadvantage',
                    params: { // here we define default value for
                        // financialadvantage
                        // we also set squash to false, to force
                        // injecting
                        // even the default value into url
                        companyDetails: {
                            value: undefined,
                        },
                        fmsmFlag :true,
                        // this param is not part of url
                        // it could be passed with $state.go or ui-sref
                        hiddenParam: 'YES'
                    },
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/analytics/creditSensitivityModel/financialAdvantage/financial_advantage.html',
                            controller: 'financialAdvantageController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {

                      /*   resolveView: ['$state', '$location', function ($state, $location) {
                            return $state.params.companyDetails ? true : $location.path('financialSensitivityMain');
                        }], */

                        loadMyCtrl: [
                            '$ocLazyLoad',
                            function ($ocLazyLoad) {
                                return $ocLazyLoad
                                    .load('famModule');

                            }
                        ],
                    }
                })
                .state('financialSensitivityFmsm', {
                parent: 'app',
                url: '/financialSensitivityFmsm?company',
                params: {
                    companyCode: null,
                    listedFlag: null,
                    segement: null,
                    hideLanding: false,
                    redirectFsmFlag:false,
                    companyflag:null 
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        controller: 'CreditSensitivityFmsmController',
                        templateUrl: 'app/analytics/creditSensitivityModel/financial_sensitivity_search.html'
                    }
                },
                resolve: {
                    loadMyCtrl: [
                        '$ocLazyLoad',
                        function ($ocLazyLoad) {
                            return $ocLazyLoad
                                .load('fsmModule');
                            /*
                             * Resolve
                             * promise
                             * and
                             * load
                             * before
                             * view
                             */
                        }
                    ]
                }
            });


    }
})();
